import { Box, styled } from '@mui/material';
import { isMobile } from 'react-device-detect';

export const StyledDefaultLayout = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    height: '100%',
  },
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  overflowX: 'hidden',
  backgroundColor: theme.palette.grey[900],
}));

export const StyledContent = styled(Box)({
  scrollBehavior: 'smooth',
  flexGrow: 1,
  overflowY: 'auto',
  overflowX: isMobile ? 'hidden' : 'auto',
  position: 'relative',
});
